module.exports = __webpack_public_path__ + "img/doggy-package-2.4ae38c7c.png";